import { ChromecastState, chromecastState } from './chromecast';
import { ConfigState, configState } from './config';
import { ErrorState, errorState } from './error';
import { InteractionsState, interactionsState } from './interactions';
import { LanguageMenuState, languageMenuState } from './languageMenu';
import { MuxState, muxState } from './mux';
import { PlayerState, playerState } from './player';
import { SettingsState, settingsState } from './settings';
import { SubtitlesState, subtitlesState } from './subtitles';
import { VHSState, vhsState } from './vhs';
import { VideosState, videosState } from './videos';

export interface StoreState {
  config: ConfigState;
  videos: VideosState;
  player: PlayerState;
  languageMenu: LanguageMenuState;
  subtitles: SubtitlesState;
  settings: SettingsState;
  vhs: VHSState;
  mux: MuxState;
  chromecast: ChromecastState;
  interactions: InteractionsState;
  error: ErrorState;
}

export const storeState: StoreState = {
  config: configState,
  videos: videosState,
  player: playerState,
  languageMenu: languageMenuState,
  subtitles: subtitlesState,
  settings: settingsState,
  vhs: vhsState,
  mux: muxState,
  chromecast: chromecastState,
  interactions: interactionsState,
  error: errorState,
};
